import { render, staticRenderFns } from "./loyalty-slider.vue?vue&type=template&id=a73d923e"
import script from "./loyalty-slider.ts?vue&type=script&lang=ts&external"
export * from "./loyalty-slider.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports